module.exports = __webpack_public_path__ + "img/ic_wifi.0607cf08.svg";